import { call, put, take, takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { api } from 'services';
import { notificationContainer } from 'utils/notificationContainer';
import {
	getConfirmedOrdersRequest,
	getConfirmedOrdersSuccess,
	getConfirmedOrdersForFilterIdRequest,
	getConfirmedOrdersForFilterIdSuccess,
	getOrderDetailsCombinedRequest,
	getOrderDetailsCombinedSuccess,
	createOrderReturnRequest,
	createOrderReturnSuccess,
	createOrderDiscountRequest,
	createOrderDiscountSuccess,
	getVatAndEASFeeRequest,
	getVatAndEASFeeSuccess,
} from './reducer';
import {
	TConfirmedOrdersResponsePayload,
	TOrdersRequest,
	TCreateOrderReturnActionPayload,
	TCreateOrderDiscountActionPayload,
	TVatAndEASFeeResponsePayload,
	TOrderDetailsCombinedRequest,
	TOrderDetailsCombinedResponsePayload,
} from './types';
import { refreshTokenByTimeOutRequest, refreshTokenByTimeOutSuccess } from '../auth/reducer';

function* getConfirmedOrdersWorker(action: PayloadAction<TOrdersRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TConfirmedOrdersResponsePayload = yield call(
			api.orders.getConfirmedOrders,
			payload,
		);
		yield put(getConfirmedOrdersSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getConfirmedOrdersForFilterIdWorker(action: PayloadAction<TOrdersRequest>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TConfirmedOrdersResponsePayload = yield call(
			api.orders.getConfirmedOrders,
			payload,
		);
		yield put(getConfirmedOrdersForFilterIdSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getOrderDetailsCombinedRequestWorker(
	action: PayloadAction<TOrderDetailsCombinedRequest>,
) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TOrderDetailsCombinedResponsePayload = yield call(
			api.orders.getOrderDetailsCombined,
			payload,
		);
		yield put(getOrderDetailsCombinedSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
	}
}

function* createOrderReturnRequestWorker(action: PayloadAction<TCreateOrderReturnActionPayload>) {
	const { orderId, ...returnPayload } = action.payload;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		yield call(api.orders.createOrderReturn, returnPayload);
		const orderDetails: TOrderDetailsCombinedResponsePayload = yield call(
			api.orders.getOrderDetailsCombined,
			{ orderId },
		);
		yield put(getOrderDetailsCombinedSuccess(orderDetails));
		yield put(createOrderReturnSuccess());
		notificationContainer('Order return created successfully', 'success');
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(error?.response?.data.message ?? error?.message ?? 'Error', 'error');
			yield put(createOrderReturnSuccess());
		}
	}
}

function* createOrderDiscountRequestWorker(
	action: PayloadAction<TCreateOrderDiscountActionPayload>,
) {
	const { orderId, ...discountPayload } = action.payload;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		yield call(api.orders.createOrderDiscount, discountPayload);
		const orderDetails: TOrderDetailsCombinedResponsePayload = yield call(
			api.orders.getOrderDetailsCombined,
			{ orderId },
		);
		yield put(getOrderDetailsCombinedSuccess(orderDetails));
		yield put(createOrderDiscountSuccess());
		notificationContainer('Order discount created successfully', 'success');
	} catch (error) {
		// console.log('error', (error as any)?.response?.data.message);
		if (axios.isAxiosError(error)) {
			notificationContainer(error?.response?.data.message ?? error?.message ?? 'Error', 'error');
			yield put(createOrderDiscountSuccess());
		}
		// yield put(assetsInitState());
	}
}

function* getVatAndEASFeeRequestWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TVatAndEASFeeResponsePayload = yield call(api.orders.getVatAndEASFee);
		yield put(getVatAndEASFeeSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
	}
}

export function* ordersSaga() {
	yield takeEvery(getConfirmedOrdersRequest.type, getConfirmedOrdersWorker);
	yield takeEvery(getConfirmedOrdersForFilterIdRequest.type, getConfirmedOrdersForFilterIdWorker);
	yield takeEvery(getOrderDetailsCombinedRequest.type, getOrderDetailsCombinedRequestWorker);
	yield takeEvery(createOrderReturnRequest.type, createOrderReturnRequestWorker);
	yield takeEvery(createOrderDiscountRequest.type, createOrderDiscountRequestWorker);
	yield takeEvery(getVatAndEASFeeRequest.type, getVatAndEASFeeRequestWorker);
}
